import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { SLOT_CAPTION } from './constants.jsx'

import styles from './Slot.scss'

const Slot = (props) => {
    const icon = !props.hasPermission ? null : (
        <div className={styles.icon} />
    )
    let dataAttrs = {}
    if (props.isOwn) {
        dataAttrs = {
            'data-tip': true,
            'data-for': `slot_${props.slotId}`,
        }
    }

    const className = classNames(styles.base, {
        [styles.base__own]: props.isOwn,
    })

    return (
        <div
            className={className}
            onClick={props.handleClick}
            onMouseEnter={props.handleHover}
            {...dataAttrs}
        >
            <div className={styles.clickArea}/>
            <p className={styles.caption}>
                <span className={styles.captionInner}>
                    {SLOT_CAPTION}
                </span>
            </p>
            {icon}
        </div>
    )
}

Slot.propTypes = {
    handleClick: PropTypes.func,
    handleHover: PropTypes.func,
    slotId: PropTypes.number.isRequired,
    hasPermission: PropTypes.bool.isRequired,
    isOwn: PropTypes.bool.isRequired,
}

export default Slot



// WEBPACK FOOTER //
// ./containers/Stronghold/components/Direction/components/Slot/Slot.jsx